
























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import * as Routes from "@/employer/route-names";
import { DrivewealthAccountSummary, InvestmentCustodian } from "@/shared/types";
import { Location } from "vue-router";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InvestmentAccountLink from "@/shared/components/investments/InvestmentAccountLink.vue";
import * as SharedRoutes from "@/shared/route-names";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner,
    InvestmentAccountLink
  }
})

export default class InvestmentAccount extends Vue {
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  hsaDailyBalanceStore = useHsaDailyBalanceStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  page: number;

  @Prop()
  routeToPages: (page: number) => Location;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  mounted (): void {
    this.drivewealthStore.loadAccountSummariesV2({username: this.username, partnerId: this.partnerId});
    this.custodianSettingsStore.getCustodianSettings({ username: this.username, partnerId: this.partnerId } as any);
    this.investmentDailyBalanceStore.loadCurrentDailyBalance({ username: this.username, partnerId: this.partnerId });
    this.investmentThresholdStore.loadInvestmentThresholds({ username: this.username, partnerId: this.partnerId });
    this.tryRedirectToCustodian();
  }

  get isPageLoaded () {
    return this.custodianSettingsStore.isLoaded &&
      this.investmentThresholdStore.thresholdsLoaded &&
      this.investmentDailyBalanceStore.currentBalanceIsLoaded &&
      this.drivewealthStore.summariesGetAllV2Loaded;
  }

  get hasCustodian () {
    return this.isPageLoaded &&
      this.investmentThresholdStore.investmentProvider &&
      this.investmentThresholdStore.investmentProvider !== InvestmentCustodian.None;
  }

  get drivewealthLocation (): Location {
    const route = {
      name: SharedRoutes.DrivewealthInvestmentAccountList,
      params: { partnerId: `${this.partnerId}` },
      query: { username: this.username }
    };
    return route;
  }

  get tdaLocation (): Location {
    return this.getRoute(Routes.TdaInvestmentAccount);
  }

  get investmentBalanceToDisplay (): number {
    return this.investmentDailyBalanceStore.sumOfAllInvestmentBalancesV2;
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange () {
    this.tryRedirectToCustodian();
  }

  @Watch("investmentThresholdStore.investmentProvider")
  @Watch("investmentDailyBalanceStore.currentBalanceIsLoaded")
  tryRedirectToCustodian () {
    if (!this.isPageLoaded) { return; }

    const location = this.investmentLandingLocation();

    if (!location) { return; }

    this.$router.push(location);
  }

  investmentLandingLocation (): Location {
    switch (this.investmentThresholdStore.investmentProvider) {
      case InvestmentCustodian.Umb:
        return this.getRoute(Routes.UmbInvestmentAccount);

      case InvestmentCustodian.Drivewealth:
        return this.drivewealthLocation;
      case InvestmentCustodian.HsaBank:
        return this.getRoute(Routes.HsabInvestmentAccount);

      default:
        return null;
    }
  }

  getRoute (routeName: string): Location {
    return {
      name: routeName,
      query: {
        username: this.username,
      },
      params: {
        partnerId: this.partnerId.toString()
      }
    };
  }
}
